import { offset, flip, shift, autoUpdate, computePosition, size, } from "@floating-ui/dom";
export const positionDropDown = ({ element, relativeTo, padding, minHeight, maxHeight, placement }) => {
    const config = {
        placement,
        middleware: [
            offset(padding),
            size({
                apply: ({ availableHeight }) => {
                    element.css({
                        maxHeight: `${Math.max(minHeight, Math.min(maxHeight, availableHeight))}px`,
                    });
                },
                padding,
            }),
            flip({
                fallbackAxisSideDirection: "start",
                fallbackStrategy: "initialPlacement",
                padding,
            }),
            shift({ padding }),
        ],
    };
    return autoUpdate(relativeTo[0], element[0], async () => {
        const { x, y } = await computePosition(relativeTo[0], element[0], config);
        element.css({
            left: `${x}px`,
            top: `${y}px`,
        });
    }, {
        animationFrame: true,
    });
};
export const getPositionOf = ({ element, relativeTo = $("body")[0], }) => {
    if (element === relativeTo)
        return {
            top: 0,
            left: 0,
        };
    const position = $(element).position();
    if (element.offsetParent) {
        const offsetParentPostion = getPositionOf({
            element: element.offsetParent,
            relativeTo,
        });
        position.top += offsetParentPostion.top;
        position.left += offsetParentPostion.left;
    }
    return position;
};
